import { user } from './user';
export var richInlineNodes = {
  user: user
};